<template>
  <div>
    <div class="columns" style="margin: 0px 0px 1px 0px">
      <div class="column column-big" label="Description">
        <b-field class="autocomplete-hide">
        <b-autocomplete
          ref="itemDescription"
          :disabled="!editing"
          required
          v-model="row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description']"
          placeholder="Description"
          :keep-first="keepFirst"
          :data="filteredDataObj"
          @select="option => selected = option">
        </b-autocomplete>
        </b-field> 
        <div class="printP">{{ row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description'] }}</div> 
      </div>
      <div class="column" label="Department">
        <b-field>
          <div v-if="editing">
            <b-select ref="department" required v-model="row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::department']" placeholder="Select">
              <option
                v-for="value in departmentValueList"
                :value="value['menu__FINANCE_DEPARTMENT__isActive__srt::name']"
                :key="value['menu__FINANCE_DEPARTMENT__isActive__srt::__kptID']">
                {{ value['menu__FINANCE_DEPARTMENT__isActive__srt::name'] }}
              </option>
            </b-select>
          </div>
          <div v-else class="moreMargin">
            {{ row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::department'] }}
          </div>
        </b-field>
      </div>
      <div class="column" label="Quantity Ordered">
        <b-field>
          <b-input
            ref="quantityOrdered"
            type="number" 
            min="1"
            :disabled="!editing" 
            v-model="row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qty']" 
            required>
          </b-input>
        </b-field>
      </div>
      <div v-if="!newPO" class="column" label="Quantity Received">
        <b-field>
                 <!--:disabled="receivedAll" -->
          <b-input 
            ref="quantityReceived"
            :disabled="!allItemsValid"
            type="number" 
            min="0"
            v-model="row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qtyReceived']">
          </b-input>
        </b-field>
      </div>
      <div class="column" label="Price">
        <b-field>
          <b-input 
            ref="price"
            type="number" 
            step="0.01"
            min="0"
            :disabled="!editing" 
            v-model="row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::price']" 
            required>
          </b-input>
        </b-field>
      </div>
      <div class="column" label="Price Per">
        <b-field>
          <b-select 
            ref="pricePer"
            type="text" 
            :disabled="!editing" 
            placeholder="Select"
            v-model="row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::pricePer']"
          >
            <option value="Each">Each</option>
            <option value="1,000">1,000</option>
          </b-select>
        </b-field>
      </div>
      <div class="column" label="Total Amount">
        <b-field class="moreMargin">
          $ {{totalPrice}}
        </b-field>
      </div>
      <div class="column" label="Tracking Number">
          <b-field v-if="editing" class="autocomplete-hide">
            <b-autocomplete
              ref="trackingNumber"
              v-model="row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::trackingNumber']"
              placeholder="Select"
              :keep-first="keepFirst"
              :data="filteredDataObjTrackingNumber"
              :open-on-focus="openOnFocus"
              :expanded="true"
              @select="option => selected = option">
            </b-autocomplete>
          </b-field> 
          <div v-else>
            <b-field class="moreMargin">
              {{ row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::trackingNumber'] }}
            </b-field>
          </div>

          <div class="printP">{{ row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::trackingNumber'] }}</div> 
      </div>
      <div class="column no-print" v-if="editing">
        <button class="button is-primary is-small" @click="removeLineItem(row)">Remove</button>
      </div>
    </div>
    <div>
      <strong><hr style="margin: -5px 0px -5px 0px"></strong>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

// Constants for indexing
const QTY = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qty';
const QTY_REC = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::qtyReceived';
const PRICE = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::price';
const PRICE_PER = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::pricePer';
const DESCRIPTION = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description';
const DEPARTMENT = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::department';
const TRACKING_NUM = 'purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::trackingNumber';


export default {
  name: 'PurchaseOrderLinesRow',
  props: ['row', 'editing', 'receiving', 'receivedAll', 'options', 'newPO', 'allItemsValid'],
  data () {
    return {
      isRemoved: false,
      keepFirst: true,
      selected: null,
      item: '',
      isValidData: false,
      openOnFocus: true
    };
  },
  computed:{
    ...mapState([
      'userInfo',
      'departmentValueList',
      'vendorValueList',
      'purchasingAgentValueList',
      'lineItemDescriptionValueList',
      'trackingNumberValueList',
      'trackingNumberOptions',
      'currentPage'
    ]),
    
    // Returns the total price for a line item
    totalPrice: function(){
      var pricePer = this.row[PRICE_PER]
      if(this.row[QTY] != null && this.row[PRICE] != null){
        if(pricePer == "Each"){
          return (this.row[QTY] * this.row[PRICE]).toLocaleString();
        }
        else if(this.row[PRICE_PER] == "1,000"){
          return (this.row[QTY] * this.row[PRICE] / 1000).toLocaleString();
        }
      }
      return 0;
    },
    
    // Constructs the autocomplete description value list as the user types
    filteredDataObj: function() {
        if( this.row[DESCRIPTION] == null){
          return [];
        }
        return this.options.filter((option) => {
            if(option){
              return option
                  .toString()
                  .toLowerCase()
                  .indexOf(this.row[DESCRIPTION].toLowerCase()) >= 0;
            }else{
              return false
            }

        });
    },
    // Constructs the autocomplete tracking number value list as the user types
    filteredDataObjTrackingNumber: function() {
        if( this.row[TRACKING_NUM] == null){
          return this.trackingNumberOptions;
        }
        return this.trackingNumberOptions.filter((option) => {
          if(option){
            return option
                .toString()
                .toLowerCase()
                .indexOf(this.row[TRACKING_NUM].toLowerCase()) >= 0;
          }else{
            return false
          }
        });
    },
    isValid: function(){
      if(this.editing == true){
        return  !(this.row[DEPARTMENT] == null || this.row[DEPARTMENT] == "") &&
                !(this.row[DESCRIPTION] == null || this.row[DESCRIPTION] == "") &&
                !(this.row[PRICE] == null || this.row[PRICE] == "") &&
                !(this.row[QTY] == null || this.row[QTY] == "") &&
                !(this.row[TRACKING_NUM] == null || this.row[TRACKING_NUM] == "");
      }
      return true;
    }
  },
  created: function(){
    this.$emit("line-rendered", null)
  },
  watch:{
    isValid: function(newValue, oldValue){
      this.row.isValid = newValue;
    }
  },
  methods:{
    // Emits to the parent to remove the selected line item
    removeLineItem: function(row){
      this.$emit('clicked-remove-line-item', row);
    },

    validate: function(){
      self = this;
      if(this.editing == true){
        var vallidity = this.$refs.itemDescription.checkHtml5Validity() &&
                        this.$refs.department.checkHtml5Validity() &&
                        this.$refs.quantityOrdered.checkHtml5Validity() &&
                        this.$refs.price.checkHtml5Validity()
                        
        // Check validity of tracking number                 
        var trackingNumberValidity = false;
        // Check for null value in tracking number
        if(self.row[TRACKING_NUM]){                
         trackingNumberValidity = this.trackingNumberOptions.some(function(trackingNumber){
            return trackingNumber.toLowerCase() == self.row[TRACKING_NUM].toLowerCase();
          });
        }
        // Tracking number is null
        else{
          trackingNumberValidity = false;
        }
        
        if(trackingNumberValidity == false && vallidity == true){
          this.$toast.open({
                    duration: 5000,
                    message: "Please fill in a valid tracking number for " + this.row['purchase_order__PURCHASE_ORDER_LINE_ITEM__purchaseOrderID::description'] + ".",
                    position: 'is-bottom',
                    type: 'is-primary'
          });
        }
      }
      else{
         var vallidity = this.$refs.quantityReceived.checkHtml5Validity()
      }
      // &&
      // this.$refs.trackingNumber.checkHtml5Validity();
      return {'valid': vallidity, 'trackingNumberValid': trackingNumberValidity};
    //   return  !(this.row[DEPARTMENT] == null || this.row[DEPARTMENT] == "") &&
    //           !(this.row[DESCRIPTION] == null || this.row[DESCRIPTION] == "") &&
    //           !(this.row[PRICE] == null || this.row[PRICE] == "") &&
    //           !(this.row[QTY] == null || this.row[QTY] == "") &&
    //           !(this.row[TRACKING_NUM] == null || this.row[TRACKING_NUM] == "");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hr{
    margin: 0px 0px 0px 0px;
  }
  .select select{
    width: 175px !important;
    max-width: 175px !important;
  }
  .column{
    width: 12.5%;
  }
.column-big{
    width: 12.5% !important;
    
  }
  @media print {
    .printP{
      display: block !important;
      margin-top: 9px;
    }
    .autocomplete-hide{
      display: none !important;
    }
     .input{
    background-color:transparent !important;
    border: none !important;
    box-shadow: none !important;
    -webkit-box-shadow: none !important;
    font-size: 11px !important;
    padding: 10px 10px 10px 10px;
    margin-top: 2px;
  }
    .input[disabled]{
      background-color: transparent !important;
      border: none !important;
      word-wrap: break-word;
    }
    .columns{
      font-size: 11px !important;
      padding: 0px;
    }
    .field{
      padding: 0px 0px 0px 0px;
      margin-top: 3px;
    }
    .select{
      font-size: 11px !important;
      display: inline;
      
    }
  .column-big{
    width: 25% !important;
    flex-basis: auto;
  }
    .column{
    width: 10.71%;
  }
    .moreMargin{
      margin-top: 9px;
    }
  }
  .printP{
    display: none;
  }
</style>

<style>
  .dropdown-menu{
    min-width: fit-content !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrder/PurchaseOrderLinesRow.vue